module.exports = __webpack_public_path__ + "assets/img/itemCardBodyBk.ae2663e8.png";